module.exports = __webpack_public_path__ + "img/web-p2-t5.ee3b7870.svg";